module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[29]28.69e4c32.woff2";